import React, { useState } from "react";
import classNames from "classnames/bind";

import PlaceholderImg from "src/assets/images/home/ad-img.png";
import { HalfMoonFill } from "src/assets/icons";

import styles from "./NewAdItem.module.scss";
const cx = classNames.bind(styles);

const NewAdItem = ({ data, ratio }) => {
  const [imgError, setImgError] = useState(false);

  return (
    <a
      href={data?.url}
      target="_blank"
      rel="noopener noreferrer"
      className={cx("ad-item-root")}
    >
      <div className={cx("head")}>
        <span className={cx("title")}>{data?.name}</span>
        <span className={cx("tag")}>AD</span>
      </div>
      <img
        src={!imgError ? data?.image : PlaceholderImg}
        alt="See more or Visits"
        onError={() => setImgError(true)}
        className={cx(ratio)}
      />
      <div className={cx("footer")}>
        <span className={cx("title")}>Visit sponsor</span>
        <span className={cx("icon-wrapper")}>
          <HalfMoonFill />
        </span>
      </div>
    </a>
  );
};

export default NewAdItem;
